/**
 * @Author: v_jppjpeng
 * @Date: 2022-09-22 17:56:19
 * @Explain: 区域
 */
export default {
  'COMMON.COUNTRY.all': 'All countries',
  'COMMON.COUNTRY.unknown': 'Unknown region',
  'COMMON.COUNTRY.100': 'Bulgaria',
  'COMMON.COUNTRY.104': 'Myanmar',
  'COMMON.COUNTRY.108': 'Burundi',
  'COMMON.COUNTRY.112': 'Belarus',
  'COMMON.COUNTRY.116': 'Cambodia',
  'COMMON.COUNTRY.120': 'Cameroon',
  'COMMON.COUNTRY.124': 'Canada',
  'COMMON.COUNTRY.132': 'Cabo Verde',
  'COMMON.COUNTRY.136': 'Cayman Islands',
  'COMMON.COUNTRY.140': 'Central African Republic',
  'COMMON.COUNTRY.144': 'Sri Lanka',
  'COMMON.COUNTRY.148': 'Chad',
  'COMMON.COUNTRY.152': 'Chile',
  'COMMON.COUNTRY.156': 'China',
  'COMMON.COUNTRY.158': 'Taiwan, Province of China',
  'COMMON.COUNTRY.162': 'Christmas Island',
  'COMMON.COUNTRY.166': 'Cocos (Keeling) Islands',
  'COMMON.COUNTRY.170': 'Colombia',
  'COMMON.COUNTRY.174': 'Comoros',
  'COMMON.COUNTRY.175': 'Mayotte',
  'COMMON.COUNTRY.178': 'Congo',
  'COMMON.COUNTRY.180': 'Congo (Democratic Republic of the)',
  'COMMON.COUNTRY.184': 'Cook Islands',
  'COMMON.COUNTRY.188': 'Costa Rica',
  'COMMON.COUNTRY.191': 'Croatia',
  'COMMON.COUNTRY.192': 'Cuba',
  'COMMON.COUNTRY.196': 'Cyprus',
  'COMMON.COUNTRY.203': 'Czechia',
  'COMMON.COUNTRY.204': 'Benin',
  'COMMON.COUNTRY.208': 'Denmark',
  'COMMON.COUNTRY.212': 'Dominica',
  'COMMON.COUNTRY.214': 'Dominican Republic',
  'COMMON.COUNTRY.218': 'Ecuador',
  'COMMON.COUNTRY.222': 'El Salvador',
  'COMMON.COUNTRY.226': 'Equatorial Guinea',
  'COMMON.COUNTRY.231': 'Ethiopia',
  'COMMON.COUNTRY.232': 'Eritrea',
  'COMMON.COUNTRY.233': 'Estonia',
  'COMMON.COUNTRY.234': 'Faroe Islands',
  'COMMON.COUNTRY.238': 'Falkland Islands (Malvinas)',
  'COMMON.COUNTRY.239': 'South Georgia and the South Sandwich Islands',
  'COMMON.COUNTRY.242': 'Fiji',
  'COMMON.COUNTRY.246': 'Finland',
  'COMMON.COUNTRY.248': 'Åland Islands',
  'COMMON.COUNTRY.250': 'France',
  'COMMON.COUNTRY.254': 'French Guiana',
  'COMMON.COUNTRY.258': 'French Polynesia',
  'COMMON.COUNTRY.260': 'French Southern Territories',
  'COMMON.COUNTRY.262': 'Djibouti',
  'COMMON.COUNTRY.266': 'Gabon',
  'COMMON.COUNTRY.268': 'Georgia',
  'COMMON.COUNTRY.270': 'Gambia',
  'COMMON.COUNTRY.275': 'Palestine, State of',
  'COMMON.COUNTRY.276': 'Germany',
  'COMMON.COUNTRY.288': 'Ghana',
  'COMMON.COUNTRY.292': 'Gibraltar',
  'COMMON.COUNTRY.296': 'Kiribati',
  'COMMON.COUNTRY.300': 'Greece',
  'COMMON.COUNTRY.304': 'Greenland',
  'COMMON.COUNTRY.308': 'Grenada',
  'COMMON.COUNTRY.312': 'Guadeloupe',
  'COMMON.COUNTRY.316': 'Guam',
  'COMMON.COUNTRY.320': 'Guatemala',
  'COMMON.COUNTRY.324': 'Guinea',
  'COMMON.COUNTRY.328': 'Guyana',
  'COMMON.COUNTRY.332': 'Haiti',
  'COMMON.COUNTRY.334': 'Heard Island and McDonald Islands',
  'COMMON.COUNTRY.336': 'Holy See',
  'COMMON.COUNTRY.340': 'Honduras',
  'COMMON.COUNTRY.344': 'Hong Kong',
  'COMMON.COUNTRY.348': 'Hungary',
  'COMMON.COUNTRY.352': 'Iceland',
  'COMMON.COUNTRY.356': 'India',
  'COMMON.COUNTRY.360': 'Indonesia',
  'COMMON.COUNTRY.364': 'Iran (Islamic Republic of)',
  'COMMON.COUNTRY.368': 'Iraq',
  'COMMON.COUNTRY.372': 'Ireland',
  'COMMON.COUNTRY.376': 'Israel',
  'COMMON.COUNTRY.380': 'Italy',
  'COMMON.COUNTRY.384': "Côte d'Ivoire",
  'COMMON.COUNTRY.388': 'Jamaica',
  'COMMON.COUNTRY.392': 'Japan',
  'COMMON.COUNTRY.398': 'Kazakhstan',
  'COMMON.COUNTRY.400': 'Jordan',
  'COMMON.COUNTRY.404': 'Kenya',
  'COMMON.COUNTRY.408': "Korea (Democratic People's Republic of)",
  'COMMON.COUNTRY.410': 'Korea (Republic of)',
  'COMMON.COUNTRY.414': 'Kuwait',
  'COMMON.COUNTRY.417': 'Kyrgyzstan',
  'COMMON.COUNTRY.418': "Lao People's Democratic Republic",
  'COMMON.COUNTRY.422': 'Lebanon',
  'COMMON.COUNTRY.426': 'Lesotho',
  'COMMON.COUNTRY.428': 'Latvia',
  'COMMON.COUNTRY.430': 'Liberia',
  'COMMON.COUNTRY.434': 'Libya',
  'COMMON.COUNTRY.438': 'Liechtenstein',
  'COMMON.COUNTRY.440': 'Lithuania',
  'COMMON.COUNTRY.442': 'Luxembourg',
  'COMMON.COUNTRY.446': 'Macau',
  'COMMON.COUNTRY.450': 'Madagascar',
  'COMMON.COUNTRY.454': 'Malawi',
  'COMMON.COUNTRY.458': 'Malaysia',
  'COMMON.COUNTRY.462': 'Maldives',
  'COMMON.COUNTRY.466': 'Mali',
  'COMMON.COUNTRY.470': 'Malta',
  'COMMON.COUNTRY.474': 'Martinique',
  'COMMON.COUNTRY.478': 'Mauritania',
  'COMMON.COUNTRY.480': 'Mauritius',
  'COMMON.COUNTRY.484': 'Mexico',
  'COMMON.COUNTRY.492': 'Monaco',
  'COMMON.COUNTRY.496': 'Mongolia',
  'COMMON.COUNTRY.498': 'Moldova (Republic of)',
  'COMMON.COUNTRY.499': 'Montenegro',
  'COMMON.COUNTRY.500': 'Montserrat',
  'COMMON.COUNTRY.504': 'Morocco',
  'COMMON.COUNTRY.508': 'Mozambique',
  'COMMON.COUNTRY.512': 'Oman',
  'COMMON.COUNTRY.516': 'Namibia',
  'COMMON.COUNTRY.520': 'Nauru',
  'COMMON.COUNTRY.524': 'Nepal',
  'COMMON.COUNTRY.528': 'Netherlands',
  'COMMON.COUNTRY.531': 'Curaçao',
  'COMMON.COUNTRY.533': 'Aruba',
  'COMMON.COUNTRY.534': 'Sint Maarten (Dutch part)',
  'COMMON.COUNTRY.535': 'Bonaire, Sint Eustatius and Saba',
  'COMMON.COUNTRY.540': 'New Caledonia',
  'COMMON.COUNTRY.548': 'Vanuatu',
  'COMMON.COUNTRY.554': 'New Zealand',
  'COMMON.COUNTRY.558': 'Nicaragua',
  'COMMON.COUNTRY.562': 'Niger',
  'COMMON.COUNTRY.566': 'Nigeria',
  'COMMON.COUNTRY.570': 'Niue',
  'COMMON.COUNTRY.574': 'Norfolk Island',
  'COMMON.COUNTRY.578': 'Norway',
  'COMMON.COUNTRY.580': 'Northern Mariana Islands',
  'COMMON.COUNTRY.581': 'United States Minor Outlying Islands',
  'COMMON.COUNTRY.583': 'Micronesia (Federated States of)',
  'COMMON.COUNTRY.584': 'Marshall Islands',
  'COMMON.COUNTRY.585': 'Palau',
  'COMMON.COUNTRY.586': 'Pakistan',
  'COMMON.COUNTRY.591': 'Panama',
  'COMMON.COUNTRY.598': 'Papua New Guinea',
  'COMMON.COUNTRY.600': 'Paraguay',
  'COMMON.COUNTRY.604': 'Peru',
  'COMMON.COUNTRY.608': 'Philippines',
  'COMMON.COUNTRY.612': 'Pitcairn',
  'COMMON.COUNTRY.616': 'Poland',
  'COMMON.COUNTRY.620': 'Portugal',
  'COMMON.COUNTRY.624': 'Guinea-Bissau',
  'COMMON.COUNTRY.626': 'Timor-Leste',
  'COMMON.COUNTRY.630': 'Puerto Rico',
  'COMMON.COUNTRY.634': 'Qatar',
  'COMMON.COUNTRY.638': 'Réunion',
  'COMMON.COUNTRY.642': 'Romania',
  'COMMON.COUNTRY.643': 'Russian Federation',
  'COMMON.COUNTRY.646': 'Rwanda',
  'COMMON.COUNTRY.652': 'Saint Barthélemy',
  'COMMON.COUNTRY.654': 'Saint Helena, Ascension and Tristan da Cunha',
  'COMMON.COUNTRY.659': 'Saint Kitts and Nevis',
  'COMMON.COUNTRY.660': 'Anguilla',
  'COMMON.COUNTRY.662': 'Saint Lucia',
  'COMMON.COUNTRY.663': 'Saint Martin (French part)',
  'COMMON.COUNTRY.666': 'Saint Pierre and Miquelon',
  'COMMON.COUNTRY.670': 'Saint Vincent and the Grenadines',
  'COMMON.COUNTRY.674': 'San Marino',
  'COMMON.COUNTRY.678': 'Sao Tome and Principe',
  'COMMON.COUNTRY.682': 'Saudi Arabia',
  'COMMON.COUNTRY.686': 'Senegal',
  'COMMON.COUNTRY.688': 'Serbia',
  'COMMON.COUNTRY.690': 'Seychelles',
  'COMMON.COUNTRY.694': 'Sierra Leone',
  'COMMON.COUNTRY.702': 'Singapore',
  'COMMON.COUNTRY.703': 'Slovakia',
  'COMMON.COUNTRY.704': 'Viet Nam',
  'COMMON.COUNTRY.705': 'Slovenia',
  'COMMON.COUNTRY.706': 'Somalia',
  'COMMON.COUNTRY.710': 'South Africa',
  'COMMON.COUNTRY.716': 'Zimbabwe',
  'COMMON.COUNTRY.724': 'Spain',
  'COMMON.COUNTRY.728': 'South Sudan',
  'COMMON.COUNTRY.729': 'Sudan',
  'COMMON.COUNTRY.732': 'Western Sahara',
  'COMMON.COUNTRY.740': 'Suriname',
  'COMMON.COUNTRY.744': 'Svalbard and Jan Mayen',
  'COMMON.COUNTRY.748': 'Eswatini',
  'COMMON.COUNTRY.752': 'Sweden',
  'COMMON.COUNTRY.756': 'Switzerland',
  'COMMON.COUNTRY.760': 'Syrian Arab Republic',
  'COMMON.COUNTRY.762': 'Tajikistan',
  'COMMON.COUNTRY.764': 'Thailand',
  'COMMON.COUNTRY.768': 'Togo',
  'COMMON.COUNTRY.772': 'Tokelau',
  'COMMON.COUNTRY.776': 'Tonga',
  'COMMON.COUNTRY.780': 'Trinidad and Tobago',
  'COMMON.COUNTRY.784': 'United Arab Emirates',
  'COMMON.COUNTRY.788': 'Tunisia',
  'COMMON.COUNTRY.792': 'Türkiye',
  'COMMON.COUNTRY.795': 'Turkmenistan',
  'COMMON.COUNTRY.796': 'Turks and Caicos Islands',
  'COMMON.COUNTRY.798': 'Tuvalu',
  'COMMON.COUNTRY.800': 'Uganda',
  'COMMON.COUNTRY.804': 'Ukraine',
  'COMMON.COUNTRY.807': 'North Macedonia',
  'COMMON.COUNTRY.818': 'Egypt',
  'COMMON.COUNTRY.826': 'United Kingdom of Great Britain and Northern Ireland',
  'COMMON.COUNTRY.831': 'Guernsey',
  'COMMON.COUNTRY.832': 'Jersey',
  'COMMON.COUNTRY.833': 'Isle of Man',
  'COMMON.COUNTRY.834': 'Tanzania, United Republic of',
  'COMMON.COUNTRY.840': 'United States of America',
  'COMMON.COUNTRY.850': 'Virgin Islands (U.S.)',
  'COMMON.COUNTRY.854': 'Burkina Faso',
  'COMMON.COUNTRY.858': 'Uruguay',
  'COMMON.COUNTRY.860': 'Uzbekistan',
  'COMMON.COUNTRY.862': 'Venezuela (Bolivarian Republic of)',
  'COMMON.COUNTRY.876': 'Wallis and Futuna',
  'COMMON.COUNTRY.882': 'Samoa',
  'COMMON.COUNTRY.887': 'Yemen',
  'COMMON.COUNTRY.894': 'Zambia',
  'COMMON.COUNTRY.998': 'European Union',
  'COMMON.COUNTRY.999': 'Unknown region',
  'COMMON.COUNTRY.004': 'Afghanistan',
  'COMMON.COUNTRY.008': 'Albania',
  'COMMON.COUNTRY.012': 'Algeria',
  'COMMON.COUNTRY.016': 'American Samoa',
  'COMMON.COUNTRY.020': 'Andorra',
  'COMMON.COUNTRY.024': 'Angola',
  'COMMON.COUNTRY.010': 'Antarctica',
  'COMMON.COUNTRY.028': 'Antigua and Barbuda',
  'COMMON.COUNTRY.032': 'Argentina',
  'COMMON.COUNTRY.051': 'Armenia',
  'COMMON.COUNTRY.036': 'Australia',
  'COMMON.COUNTRY.040': 'Austria',
  'COMMON.COUNTRY.031': 'Azerbaijan',
  'COMMON.COUNTRY.044': 'Bahamas',
  'COMMON.COUNTRY.048': 'Bahrain',
  'COMMON.COUNTRY.050': 'Bangladesh',
  'COMMON.COUNTRY.052': 'Barbados',
  'COMMON.COUNTRY.056': 'Belgium',
  'COMMON.COUNTRY.084': 'Belize',
  'COMMON.COUNTRY.060': 'Bermuda',
  'COMMON.COUNTRY.064': 'Bhutan',
  'COMMON.COUNTRY.068': 'Bolivia (Plurinational State of)',
  'COMMON.COUNTRY.070': 'Bosnia and Herzegovina',
  'COMMON.COUNTRY.072': 'Botswana',
  'COMMON.COUNTRY.074': 'Bouvet Island',
  'COMMON.COUNTRY.076': 'Brazil',
  'COMMON.COUNTRY.086': 'British Indian Ocean Territory',
  'COMMON.COUNTRY.096': 'Brunei Darussalam',
  'COMMON.COUNTRY.090': 'Solomon Islands',
  'COMMON.COUNTRY.092': 'Virgin Islands (British)',
};
